import Link from '@components/common/Link/Link'
import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { FC } from 'react'
import Media from '../Media/Media'
import s from './BlogPostCard.module.scss'
export interface BlogPostCardProps {
  imageSrc: string
  title: string
  linkSrc: string
}
const BlogPostCard: FC<BlogPostCardProps> = ({ imageSrc, title, linkSrc }) => {
  return (
    <li className={s.root}>
      <div className={s.imageWrapper}>
        <Link link={{ url: linkSrc }} className={s.link}>
          <Media
            mediaWithCrops={
              {
                url: imageSrc,
                media: {
                  __typename: 'Image',
                  url: imageSrc,
                },
              } as MediaWithCropsFragment
            }
            className={clsx(s.imageContainer)}
            mediaClassName={clsx(s.image)}
            scaleOnHover
            disableShopTheLook
          />
        </Link>
      </div>
      <Link link={{ url: linkSrc }} className={s.link}>
        <div className={s.productDetails}>
          <div className={s.productDetailsDescription}>
            <h2 className={s.productName}>{title}</h2>
          </div>
        </div>
      </Link>
    </li>
  )
}

export default BlogPostCard
